module.exports = __webpack_public_path__ + "fransa mutfak 2.jpg?1ce67e8efc73d13dce8db7640499a2d2";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 2.jpg
// module id = 334
// module chunks = 0